<template>
  <div class="at-a-glance-table-container">
    <div class="at-a-glance-table" v-if="cwaData.length > 1">
      <AtAGlanceIndicatorTableHeaderRow
        :rowData="multiHeaderColumns"
        :firstRow="true"
        :hasHighlight="true"
      />
    </div>
    <div
      class="at-a-glance-table"
      v-for="(data, index) in cwaData"
      :key="index"
    >
      <AtAGlanceIndicatorTableHeaderRow
        :rowData="data.ColumnHeaders"
        :firstRow="cwaData.length == 1"
      />
      <AtAGlanceIndicatorTableRow
        v-for="(rowData, secondIndex) in visibleRowData(data.IndicatorData)"
        :key="secondIndex"
        :rowData="rowData"
        :isLastRow="
          secondIndex == data.IndicatorData.length - 1 &&
          parseInt(index) === cwaData.length - 1
        "
        :hasHighlight="rowData.Highlight.length > 0"
        :fromDashboard="true"
        :isGlobal="rowData.IsGlobal"
        @remove-aag="removeAAG($event)"
      />
    </div>
    <div v-if="showButton" class="at-a-glance-table__expand-button">
      <div @click="expand = !expand" class="button">
        <div class="button-text">
          {{ expand ? 'Collapse Table' : 'Expand Table' }}
        </div>
        <div class="button-icon">
          <IconChevronCircleDown :isActive="!expand" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import IconChevronCircleDown from '~/components/icon/IconChevronCircleDown.vue';
  import AtAGlanceIndicatorTableRow from '~/components/trendsreport/html/AtAGlanceComponents/AtAGlanceIndicatorTableRow.vue';
  import AtAGlanceIndicatorTableHeaderRow from '~/components/trendsreport/html/AtAGlanceComponents/AtAGlanceIndicatorTableHeaderRow.vue';
  import { useAAGStore } from '~/stores/aag';

  export default {
    name: 'AtAGlanceDashboardTable',
    components: {
      IconChevronCircleDown,
      AtAGlanceIndicatorTableRow,
      AtAGlanceIndicatorTableHeaderRow,
    },
    emits: ['remove-aag'],
    props: {
      cwaData: {
        type: Object,
        required: true,
      },
    },
    data: () => ({
      expand: localStorage.getItem('myaag-table-state')
        ? JSON.parse(localStorage.getItem('myaag-table-state'))
        : false,
      multiHeaderColumns: [
        '',
        'Rate-of-Change',
        'Data Trend',
        '',
        '',
        '',
        '',
        'Highlights',
      ],
      threshold: 2,
    }),
    setup() {
      const aagStore = useAAGStore();
      return { aagStore };
    },
    mounted() {
      this.threshold = this.cwaData.length < 3 ? 4 : 2;
    },
    computed: {
      showButton() {
        return this.cwaData.some(
          (data) => data.IndicatorData.length > this.threshold
        );
      },
    },
    methods: {
      async removeAAG(data) {
        let body = {
          DOSCode: encodeURIComponent(data.DOSCode),
          IsGlobal: data.IsGlobal,
          TREditionID: data.TREditionID,
        };
        await axios.post('/trendsreport/tr-remove-aag', body).catch((err) => {
          // TODO: HANDLE ERROR - This is just silencing the error
        });
        await this.aagStore.getAAGDashboard();
      },
      visibleRowData(data) {
        if (this.showButton && !this.expand) {
          return data.slice(0, this.threshold);
        }
        return data;
      },
    },
    watch: {
      expand(newVal) {
        localStorage.setItem('myaag-table-state', JSON.stringify(newVal));
      },
    },
  };
</script>

<style lang="scss" scoped>
  .at-a-glance-table {
    display: grid;
    grid-template-columns:
      minmax(250px, 1fr)
      98px 96px 120px 92px 92px 92px minmax(450px, 1fr);
    grid-template-rows: auto;
    // overflow-x: auto;
    &__expand-button {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: flex-end;
      margin-top: 1rem;
      .button {
        display: flex;
        flex-wrap: nowrap;
        align-items: center;
        padding: 2px 16px 2px 24px;
      }
      .button-icon {
        height: 24px;
        margin-left: 1rem;
      }
    }
  }
  .at-a-glance-table-container {
    margin-bottom: 2rem;
    overflow-x: auto;
  }
</style>